export default __webpack_public_path__ + "static/media/loadingNew.dfa8b341.gif";